import * as actionTypes from '../actions/actionTypes'

const initialState = {
    termsConditions : '',
    privacyPolicy : '',
    loadError : null
}

const gdprReducer = (state = initialState, actions) => {
    switch(actions.type){
        case actionTypes.GDPR_SUCCESS_PRIVACY_POLICY:
            return {
                ...state,
                privacyPolicy : actions.privacyPolicy
            }
        case actionTypes.GDPR_SUCCESS_TERMS_CONDITIONS:
            return {
                ...state,
                termsConditions : actions.termsConditions
            }
        case actionTypes.GDPR_LOAD_STARTED:
            return {
                ...state,
                loadError : null
            }
        case actionTypes.GDPR_LOAD_FAILED:
            return {
                ...state,
                loadError : actions.loadError
            }
        default:
            return state
    }
}

export default gdprReducer



// WEBPACK FOOTER //
// ./src/store/reducers/gdprReducer.js